export const extractRepositoryDetails = (url?: string) => {
  if (!url) {
    return {};
  }
  try {
    const currentURL = new URL(url);
    return extractDetails(cleanupPath(currentURL));
  } catch {
    return {
      namespace: null,
      repository: null,
      err: "Invalid url, example valid url: https://example.com",
    };
  }
};

const cleanupPath = (url: URL) => {
  // trim first slash
  const pathname = url.pathname.substring(1);
  // trim .git suffix
  return pathname.substring(0, pathname.lastIndexOf(".git")) || pathname;
};

const extractDetails = (pathname: string) => {
  const index = pathname.lastIndexOf("/");
  return {
    namespace: pathname.substring(0, index),
    repository: pathname.substring(index + 1),
    err: null,
  };
};
